module.exports = __webpack_public_path__ + "files/d9429708a53fe80e48abbff145975a36.png";